import styled from "styled-components";
import { media, theme } from "../../theme/theme";
import { V3Body, V3HeadlineH4, V3SubtitleMedium } from "../Typography";
import { CustomInpHover, V3CbLb } from "../OptionInput/V3OptionInput.styles";

const BULK_BR = 750;
export const CONTENT_LIST_MOBILE_BR = 1426;

export const ContentListItemWrapper = styled.div<{ $isSelectOnly: boolean}>`
    display: flex;
    width: 100%;
    align-items: center;
    position: relative;
    border-radius: ${({ $isSelectOnly}) => !$isSelectOnly ? "12px" : undefined};
    padding: 9px 20px;
    margin: ${({ $isSelectOnly }) => !$isSelectOnly ? "0 0 0 -20px" : undefined};
    width: ${({ $isSelectOnly }) => !$isSelectOnly ? "calc(100% + 40px)" : undefined};

    ${media.custom(CONTENT_LIST_MOBILE_BR)} {
        padding: ${({ $isSelectOnly }) => !$isSelectOnly ? "9px 36px" : "9px 32px"};
        margin: ${({ $isSelectOnly }) => !$isSelectOnly ? "0 0 0 -36px" : undefined};
        width: ${({ $isSelectOnly }) => !$isSelectOnly ? "calc(100% + 64px)" : undefined};
    }
    
    &:hover {
        background: ${({ theme}) => theme ? theme.v3.colors.grey96 : undefined};
        cursor: ${({ theme, $isSelectOnly }) => $isSelectOnly ? "pointer" : theme.v3.colors.grey96};

        ${V3HeadlineH4}, 
        ${V3Body} {
            color: ${({ theme, $isSelectOnly}) => !$isSelectOnly ? theme.v3.colors.blue : undefined};
        }

        ${V3CbLb} {
            &:before {
                ${({ $isSelectOnly }) => $isSelectOnly ? CustomInpHover : undefined};
            }
        }

    }

    > div {
        &:first-child {
            display: ${({ $isSelectOnly }) => !$isSelectOnly? "none" : undefined};
            margin-right: ${({ theme }) => `${theme.v3.spacings.spacing5}px`};
            
            ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
                display: block;
            }
        }
    }
`;

export const BulkActionsPanel = styled.div`
    padding: 18px 42px;
    background: ${({ theme }) => theme.v3.colors.blue};
    box-shadow: 0px -2px 18px -6px rgba(27, 34, 50, 0.3);
    border-radius: 8px 8px 0px 0px;
    text-align: center;

    ${media.custom(BULK_BR)} {
        text-align:initial;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    ${V3SubtitleMedium} {
        color: white;
    }
`;


export const BulkActionRightPanel = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 14px;

    ${media.custom(BULK_BR)} {
        margin-top: 0;
        flex-direction: row;
    }

    > div {
        display: inline-flex;
        margin-bottom: 14px;
        
        ${media.custom(BULK_BR)} {
            margin-bottom: 0;
        }

        &:nth-child(1) {
            margin-top: 3px;
        }

        &:nth-child(1),
        &:nth-child(2) {
            ${media.custom(BULK_BR)} {
                margin-right: 25px;
            }
        }

        &:nth-child(4) {
            position: absolute;
            top: 15px;
            right: 15px;

            ${media.custom(BULK_BR)} {
                position: static;
                top: initial;
                right: initial;
            }
        }

        &:hover {
            cursor: pointer;
        }
    }
`;

export const ContentListLoaderOffset = styled.div`
    ${media.custom(theme.v3.layout.sidebarLayout.mobile)} {
        padding-left: 45px;
    }
`;